import React, { Component } from 'react';
import { connect } from 'react-redux';
import "react-tabs/style/react-tabs.css";
import NewWindow from 'react-new-window'

import MemberListItem from './MemberListItem';
import ChatBoxTabsWindow from './ChatBoxTabsWindow';
import ErrorBoundary from './ErrorBoundary';
import { focusNamedWindow } from '../utils/popupWindows';
import { CHAT_WINDOW } from '../utils/windowNames';
import PopupBlockedDialog from './PopupBlockedDialog';
import memberActions from '../actions/member_actions';
import chatActions from '../actions/chat_actions';
import userActions from '../actions/user_actions';
import windowActions from '../actions/window_actions';
import { flashApp } from '../utils/flashNotification';
import { getPref } from '../utils/notificationPreferences';

// How long the startup chat window waits on api/user/GetUnreadMessages before
// opening without it. The 5s the whole thing used to wait, kept as a ceiling.
const STARTUP_UNREAD_DEADLINE_MS = 5000;

// How many conversations get a tab of their own: ChatBoxTabsWindow's
// numberOfTabs. Anything past it is reachable only through that window's
// overflow dropdown, which is why a message or a click for someone down there
// moves them to the front. Opening a new conversation evicts the oldest only
// once the tabs are full - it used to evict at five, so the sixth tab the
// window has room for was never used, and the eviction itself took a
// different recipient off state than it took off the list it then saved.
export const MAX_CHAT_TABS = 6;

// The recipients with newRecipient opened at the front, or null if they are
// already open. Never touches the array it is given. Evicts one, the oldest,
// when the tabs are full: the startup restore can open more than
// MAX_CHAT_TABS at once, and opening one more conversation should not
// silently close several of those.
export const withNewRecipient = (recipients, newRecipient) => {
    if (recipients.some(r => r['id'] === newRecipient['id'])) {
        return null;
    }
    var kept = recipients.length >= MAX_CHAT_TABS ? recipients.slice(0, recipients.length - 1) : recipients;
    return [newRecipient].concat(kept);
};

// A copy with the recipient at index moved to the front.
export const movedToFront = (recipients, index) => {
    var copy = recipients.slice();
    copy.unshift(copy.splice(index, 1)[0]);
    return copy;
};

export class MemberList extends Component {
    constructor(props) {
        super(props);
        // this.textField = React.createRef();
        this.state = {
            hub: {},
            unreadMessages: {},
            features: {
                width: 450,
                height: 450,
                top: window.screenTop,
                left: window.screenLeft + 205, // window.innerWidth + 5, // some space + 5 (local)
                screenX: window.screenX + 205, // window.innerWidth + 5, // some space + 5
                screenY: window.screenY,
                alwaysRaised: "yes",
                alwaysOnTop: true,
            },
            chatBoxTabsOpen: false,
            popupsBlocked: false,
            recipients: [], // list of recipients obj, passed up from MemberListItem
            disableUnread: false,
            logoutClicked: false,
            hiddenTabs: [],
            displayedTabs: [],
            focusedUserTab: {}
        };
    };

    componentDidMount() {
        // Removed `this.state = {}` here: assigning to this.state directly threw
        // away everything the constructor set (recipients, hiddenTabs, ...) and
        // desynced React's memoized state, which produced the "Expected
        // MemberList state to match memoized state" warning on every mount.
        this.props.populateMemberList();
        this.props.getUnreadMessages();  // pulls all messages from history and treats as unread messages
        this.subscribeToMessages();
        this.openChatAtStartup();
        // The startup window used to wait a flat 5s here, so it came up well
        // after the bulletin. It now opens as soon as the members, unread set
        // and preferences have answered (componentDidUpdate); this deadline
        // only stops a failed unread fetch from holding it back for good.
        this.startupTimer = setTimeout(() => {
            this.startupDeadlinePassed = true;
            this.openChatAtStartup();
        }, STARTUP_UNREAD_DEADLINE_MS);
        ////////////////////////////////////////////////////////////////////////////
        // Position Chat Window Next to Member List

        this.setState({
            features: {
                width: 450,
                height: 450,
                top: window.screenTop,
                left: window.screenLeft + 205, // window.innerWidth + 5, // some space + 5 (local)
                screenX: window.screenX + 205, // window.innerWidth + 5, // some space + 5
                screenY: window.screenY,
                alwaysRaised: "yes",
                alwaysOnTop: true,
            }
        });

        //////////////////////////////////////////////////////////////////////////////////
    };

    componentDidUpdate() {
        this.subscribeToMessages();
        this.openChatAtStartup();
    };

    componentWillUnmount() {
        clearTimeout(this.startupTimer);
    };

    // state.hub is {} until App's connection.start() resolves, so this runs
    // again from componentDidUpdate until the real connection arrives. It used
    // to be tried once, 5s after mount, and a slower connection than that
    // left the member list deaf to NewMessage for the whole session.
    subscribeToMessages = () => {
            if (!this.messagesBound && localStorage.getItem("token") !== null && this.props.hub && typeof this.props.hub.on === 'function') {
                this.messagesBound = true;
                this.props.hub.on('NewMessage', (message => {
                    if (message.payload.userId !== this.props.profile.id && !this.state.recipients.includes(message.payload.userId)) {
                        // var sender = this.props.memberIdMap[message.payload.userId];
                        // this.addNewRecipient(sender, false); // called every time a new message is received
                        if (this.state.recipients.length === 0) {
                            if (flashApp(this.props.preferences, 'flashstart')) {
                                this.props.setIconFlash(true);
                            }
                        }

                        var sender = this.props.memberIdMap[message.payload.userId]; ///////////////////////////////////////////////////////
                        for (var i = 0; i < this.state.recipients.length; i++) {
                            if (this.state.recipients[i]['id'] === sender['id']) {
                                if (i >= MAX_CHAT_TABS) {
                                    this.setState({ recipients: movedToFront(this.state.recipients, i) });
                                    this.props.updateTabIndex(this.props.currentTabIndex + 1);
                                    this.focusChatWindow();
                                    // window.open("", "ChatBoxWindow").focus();
                                    return;
                                }
                                return;
                            }
                        }
                        this.focusChatWindow();
                        // setTimeout(function () { window.open("", "ChatBoxWindow").focus(); }, 200);

                        this.addNewRecipient(sender, false, false);
                        if (this.state.recipients.length === 1) {
                            this.props.updateTabIndex(0);
                        }
                    }
                }))
            }
    };

    // The startup.openChatWindow preference, acted on once per page load
    // (signing in reloads the page, so that is once per login). Waits for the
    // preferences like UserHub.checkBulletinSchedule does - an empty map reads
    // as 'always' and would pop the window up for someone who chose 'never'.
    openChatAtStartup = () => {
            if (this.chatStartupHandled || localStorage.getItem("token") === null) {
                return;
            }
            if (!this.props.profile || this.props.profile.id === undefined || !this.props.preferencesLoaded || this.props.members.length === 0) {
                return;
            }
            if (!this.props.unreadLoaded && !this.startupDeadlinePassed) {
                return;
            }
            this.chatStartupHandled = true;
            const unreadMessages = [];

            if (this.props.profile.id !== undefined) {
                // Open Chat Window When Unread Messages Are Present
                this.props.members.forEach(member => {
                    if (this.props.unreadMessages[member.id]) unreadMessages.push(member);
                });

                // 'always' reproduces the original behaviour, including the self-tab
                // when nothing is unread. 'unread' drops only that self-tab case.
                // 'never' leaves the window closed - unread senders stay marked in the
                // member list either way, so this hides the window, never the fact.
                const openWhen = getPref(this.props.preferences, 'startup', 'openChatWindow');
                const hasUnread = unreadMessages.length > 0;

                if (openWhen !== 'never' && (hasUnread || openWhen === 'always')) {
                    if (unreadMessages.length === 0) {
                        // Populate chatbox with user info if no unread messages
                        this.props.members.forEach(member => {
                            if (this.props.profile.id === member.id)
                                unreadMessages.push(member);
                        });
                    }
                    for (var i = 0; i < unreadMessages.length; i++) {
                        this.props.updateTabIndex(i);
                    }
                    this.setState({ chatBoxTabsOpen: false }, () => {
                        this.setState({ recipients: unreadMessages, chatBoxTabsOpen: true }, () => { this.props.updateTabIndex(this.state.recipients.length - 1) });
                        this.props.setChatDisplay(true);
                    });
                }
            }
    };

    memberIsClicked = (newRecipient, shouldRefresh, shouldSetToEnd = false, moveToFront = false) => {

        for (var i = 0; i < this.state.recipients.length; i++) {
            if (this.state.recipients[i]['id'] === newRecipient['id']) {
                if (i >= MAX_CHAT_TABS) {
                    this.setState({ recipients: movedToFront(this.state.recipients, i) });
                    this.props.updateTabIndex(0);
                    this.focusChatWindow();
                    // window.open("", "ChatBoxWindow").focus();
                    return;
                }
                this.props.updateTabIndex(i);
                this.focusChatWindow();
                // window.open("", "ChatBoxWindow").focus();

                return;
            }
        }
        this.addNewRecipient(newRecipient, shouldRefresh, shouldSetToEnd);
        this.props.updateTabIndex(0);
        this.focusChatWindow();
    };

    addNewRecipient = (newRecipient, shouldRefresh, shouldSetToEnd = false) => {
        // Evicting used to go through removeRecipient, which spliced
        // this.state.recipients in place, while this trimmed its own copy at
        // index 4. The copy is what got saved, so the two only agreed at
        // exactly five tabs; past that a visible tab was evicted and the
        // oldest kept. withNewRecipient does both on one copy.
        var updatedRecipients = withNewRecipient(this.state.recipients, newRecipient);
        if (updatedRecipients === null) {
            return;
        }

        if (shouldRefresh && localStorage.token !== "" && localStorage.token !== null) { // chat box still opens after logging out

            //this.props.setChatDisplay(false); 
            //this.props.setChatDisplay(true);
            this.setState({ chatBoxTabsOpen: false }, () => {
                this.setState({ recipients: updatedRecipients, chatBoxTabsOpen: true });
                this.props.setChatDisplay(true);

            });
        } else {
            this.setState({ recipients: updatedRecipients, chatBoxTabsOpen: true });
            this.props.setChatDisplay(true);
        }
        //this.props.updateTabIndex(0);
        this.props.updateTabIndex(this.props.currentTabIndex + 1);
        this.focusChatWindow();
    };

    removeRecipient = (recipientToRemove) => {
        var recipientToRemoveId = recipientToRemove.id; // extract recipientToRemove id

        // A copy, saved through setState. This used to splice
        // this.state.recipients in place and never call setState, so the tab
        // only went away whenever something else happened to re-render.
        var recipientsCopy = this.state.recipients.filter(r => r.id !== recipientToRemoveId);
        if (recipientsCopy.length === 0) {
            this.setState({ recipients: recipientsCopy, chatBoxTabsOpen: false });
            this.props.setChatDisplay(false);
        } else {
            this.setState({ recipients: recipientsCopy });
        }

        setTimeout(function () {
            if (this.state.chatBoxTabsOpen) {
                this.props.updateTabIndex(0);
            }
        }.bind(this), 50);
    };

    closeChatBoxTabs = () => {
        this.setState({ recipients: [], chatBoxTabsOpen: false });
        this.props.setChatDisplay(false);
    };

    // window.open returns null when the pop-up is blocked, and these call sites
    // used to go straight to .focus() on it. Six of them, all reachable from an
    // arriving message or a click on a member, so a blocked pop-up threw from
    // whichever one ran first.
    //
    // Passing "" as the URL only ever *re-focuses* a window that already
    // exists; it never creates the chat window - <NewWindow> does that. So
    // there is nothing to recover here beyond not throwing, and if it comes
    // back null the pop-up notice is the right response.
    focusChatWindow = () => {
        if (!focusNamedWindow(CHAT_WINDOW,'location=0,width=450,height=450')) {
            this.handlePopupBlocked();
        }
    };

    // <NewWindow> hands over the real window object here. Stored so the
    // notification code can ask whether the user is already looking at chat
    // without calling window.open, which would create a blank window.
    handleChatWindowOpen = (chatWindow) => {
        this.props.setChatWindow(chatWindow);
    };

    handlePopupBlocked = () => {
        if (this.state.popupsBlocked) {
            return;
        }
        // Stop asking for the window as well as reporting it. Leaving
        // shouldDisplayChat true would have the boundary's subtree rebuilt on
        // the next render and fail again.
        this.setState({ popupsBlocked: true });
        this.props.setChatDisplay(false);
    };

    dismissPopupNotice = () => {
        this.setState({ popupsBlocked: false });
    };

    // Once they have allowed pop-ups there is nothing to reload - asking for
    // the chat window again is enough, and it is a click, so it is user-
    // initiated and the browser is far more willing.
    retryPopup = () => {
        this.setState({ popupsBlocked: false }, () => {
            this.props.setChatDisplay(true);
        });
    };

    passDisableUnreadToChild = () => {
        this.setState({ disableUnread: true });
    };

    render() {
        const inOffice = []; //online
        const outOffice = []; //offline
        this.props.members.forEach((member) => {
            if (member.inOffice === true) {
                inOffice.push( //online
                    <MemberListItem
                        member={member}
                        key={member.id}
                        hasUnreadMessage={this.props.unreadMessages[member.id] ? true : false}
                        callbackFromParent={this.memberIsClicked}//{this.addNewRecipient}
                        disableUnread={this.state.disableUnread}
                    />
                );
            }
            else if (member.inOffice === false) {
                outOffice.push( //offline
                    <MemberListItem
                        member={member}
                        key={member.id}
                        hasUnreadMessage={this.props.unreadMessages[member.id] ? true : false}
                        callbackFromParent={this.memberIsClicked}//{this.addNewRecipient}
                        disableUnread={this.state.disableUnread}
                    />
                );
            }
        });
        let chatBoxTabsWindow;
        if (this.props.shouldDisplayChat === true) { //focusChatBox={this.state.focusChatBox}
            // The boundary is what stops a blocked pop-up whiting out the whole
            // app: react-new-window@0.1.3 dereferences the null from
            // window.open inside componentDidMount, and an error escaping a
            // commit-phase lifecycle makes React 16 unmount everything. onBlock
            // is passed too because that is the library's intended signal and it
            // costs nothing, but it is unreachable in this version - the throw
            // happens first - so the boundary is the one doing the work.
            chatBoxTabsWindow =
                <ErrorBoundary onError={this.handlePopupBlocked}>
                    <NewWindow id="test" name={CHAT_WINDOW} onUnload={this.closeChatBoxTabs} onOpen={this.handleChatWindowOpen} onBlock={this.handlePopupBlocked} features={this.state.features} title={'TeamX'}> {/*center={'parent'} center={'screen'}*/ /*alwaysRaised={'yes'}*/}
                        <ChatBoxTabsWindow
                            recipients={this.state.recipients}
                            callbackFromParentRemove={this.removeRecipient}
                            callbackFromParent={this.memberIsClicked} //{this.addNewRecipient}
                            onClick={this.passDisableUnreadToChild} />
                    </NewWindow>
                </ErrorBoundary>;
        } else {
            chatBoxTabsWindow = <div></div>;
        }

        //if (this.props.logoutclicked) {
        //  console.log("logout clicked MemberList.js");
        //  this.setstate({ logoutclicked: true }, () => {
        //    this.closechatboxtabs();
        //    this.setstate({ logoutclicked: false });
        //  });
        //}
        return (
            <div style={{ width: '100% !important' }}>
                <h5 style={{ backgroundColor: '#e5e5e5', padding: '6px', margin: '0px' }}><b><i>Online</i></b></h5>
                <ul style={{ padding: '2px', margin: '0px' }}>{inOffice}</ul>
                <h5 style={{ backgroundColor: '#e5e5e5', padding: '6px', margin: '0px' }}><b><i>Offline</i></b></h5>
                <ul style={{ padding: '2px', margin: '0px' }}>{outOffice}</ul>
                {chatBoxTabsWindow}
                <PopupBlockedDialog
                    open={this.state.popupsBlocked}
                    what={'the chat window'}
                    onRetry={this.retryPopup}
                    onDismiss={this.dismissPopupNotice} />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        hub: state.hub,
        members: state.members,
        unreadMessages: state.unreadMessages,
        memberIdMap: state.memberIdMap,
        profile: state.profile,
        shouldDisplayChat: state.shouldDisplayChat,
        currentTabIndex: state.currentTabIndex,
        shouldTurnFlashOn: state.shouldTurnFlashOn,
        preferences: state.preferences,
        preferencesLoaded: state.preferencesLoaded === true,
        unreadLoaded: state.unreadLoaded === true,
        // openChatBoxTabsWindow: state.openChatBoxTabsWindow,
    };
}

const mapDispatchToProps = dispatch => ({
    updateTabIndex: (tabIndex) => dispatch(chatActions['TAB_INDEX'](tabIndex)),
    populateMemberList: () => dispatch(memberActions['FETCH_MEMBERS']()),
    setChatDisplay: shouldDisplay => dispatch(windowActions['SET_CHAT_DISPLAY'](shouldDisplay)),
    setChatWindow: chatWindow => dispatch(windowActions['SET_CHAT_WINDOW'](chatWindow)),
    setIconFlash: shouldTurnFlashOn => dispatch(windowActions['SET_ICON_FLASH'](shouldTurnFlashOn)),
    getUnreadMessages: () => dispatch(userActions['UNREAD_MESSAGE_FETCH']()),
    getUnreadMessageUser: () => dispatch(userActions['UNREAD_MESSAGE_USER_FETCH']()),
    //updateChatBoxTabsWindow: () => dispatch(chatWindowActions['CLOSE_CHATWINDOW']()),
})

export default connect(mapStateToProps, mapDispatchToProps)(MemberList);



// WEBPACK FOOTER //
// ./src/components/MemberList.js